import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a5ae332"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "decoration"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "decoration-item" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "body" }
const _hoisted_6 = {
  key: 1,
  class: "decoration"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "decoration-item2" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "popUp",
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.emit('hide'))),
    ref: "popUp"
  }, [
    _createVNode(_Transition, { name: "popUp" }, {
      default: _withCtx(() => [
        _createElementVNode("nav", {
          class: "bottom-navigation",
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
          style: _normalizeStyle({'top': _ctx.mouseHeight + 'px'})
        }, [
          (!_ctx.hideTopDecoration)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", null, [
              _renderSlot(_ctx.$slots, "title", {}, undefined, true)
            ]),
            _renderSlot(_ctx.$slots, "top-right", {}, undefined, true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "body", {}, undefined, true)
          ]),
          (!_ctx.hideBottomDecoration)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
            : _createCommentVNode("", true)
        ], 4)
      ]),
      _: 3
    })
  ], 512))
}